import { jsx as r, jsxs as o } from "react/jsx-runtime";
import "react";
var i = (t) => /* @__PURE__ */ o("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 36 36",
  ...t,
  children: [/* @__PURE__ */ r("rect", {
    width: 34.955,
    height: 4.45,
    fill: "currentColor",
    rx: 2.225,
    transform: "scale(1.0049 .99507) rotate(45 -1.621 10.75)"
  }), /* @__PURE__ */ r("rect", {
    width: 34.955,
    height: 4.45,
    fill: "currentColor",
    rx: 2.225,
    transform: "matrix(-.71057 .70362 -.71057 -.70362 32 7.13)"
  })]
});
export {
  i as default
};
